import * as React from "react";
import ServicesContext from "../../contexts/servicesContext";
import { ErrorDialog } from "../error-dialog";

interface ErrorBoundaryState {
    hasError: boolean
}

class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
    static contextType = ServicesContext;
    context: React.ContextType<typeof ServicesContext>;

    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch() {
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorDialog descriptionText={this.props.resourceProvider.getText("Error_General_Description")} headingText={this.context.resourceProvider.getText("Error_General_Title")} />;
        } else {
            return this.props.children;
        }
    }
}

export default ErrorBoundary;